import React from 'react';
import ButtonDelete from './ButtonDelete';
import EditableField from './EditableField';
import EditableDropdown from './EditableDropdown';
import { matchesISBNString } from '../helpers/Validations';
import * as warnings from '../constants/ValidationWarnings';

export default class Isbn extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { editing: false };
  }

  clickCreatorNameHandle = () => {
    this.setState({ editing: true });
  }

  clearEdit = () => {
    this.setState({ editing: false });
  }

  // no validation atm
  validateIsbn(name) {
    return /^.+$/.test(name);
  }

  render() {
    return (<tr>
      <td className="section-table-head">
        <span className="isbn-category">
          {this.props.category}
        </span>
      </td>
      <td
        className="item-name"
      >
        <EditableField
          itemRef="number"
          title="Enter an ISBN"
          id={this.props.id}
          text={this.props.number}
          update={this.props.update}
          validate={matchesISBNString}
          warning={warnings.ISBN}
        />
      </td>
      <td className="section-table-remove">
        <ButtonDelete
          size='sm'
          title='Remove creator'
          id={`creator-${this.props.id}`}
          className="pull-md-right"
          action={() => this.props.destroy(this.props.id)}
          disabled={!this.props.number}
          noConfirm
        />
      </td>
    </tr>);
  }
}
